export class IssueFilterModel {
  customerNumber: string;
  quickSearch: string;
  siteId: string;
  siteNumber: string;
}
